import { useState, useEffect, useMemo } from 'react';

import { useStores } from 'mobx/hooks/useStores';

import { checkForMatchingClinicianAlerts, getTriggeredSymptomsInfo } from 'utils/urgencyAlertUtils';

import { AlertUrgency } from 'constants/urgency.consts';

import { TicketFormField } from './ticket.shared';

export function useClinicianAlerts(
  patientId: number,
  ticketSubTypeIds: string[] | (string | number)[],
  ticketData: TicketFormField | TicketFormField[]
) {
  const { alertsStore, constantsStore } = useStores();
  const { globalAlerts } = alertsStore;

  const [alertTriggeredBySymptomId, setAlertTriggeredBySymptomId] = useState<
    Map<number, AlertUrgency>
  >(new Map());

  useEffect(
    function calculateSuggestedUrgencyByClinicianAlerts() {
      const alertsResult = checkForMatchingClinicianAlerts(
        Array.isArray(ticketData) ? ticketData : [ticketData],
        patientId,
        globalAlerts
      );
      setAlertTriggeredBySymptomId(alertsResult.alertTriggeredBySymptomId);
    },
    // note: include ticketSubTypeIds to update on symptom change
    [ticketSubTypeIds, ticketData, globalAlerts, patientId]
  );

  const { getCauseNameById } = constantsStore;

  const triggeredSymptoms = useMemo(
    () => getTriggeredSymptomsInfo(ticketSubTypeIds, alertTriggeredBySymptomId, getCauseNameById),
    [ticketSubTypeIds, alertTriggeredBySymptomId, getCauseNameById]
  );

  return { triggeredSymptoms };
}
